import React from "react";
import { Link } from "gatsby";

function NavBarProducts({ mobile = false }) {
  let navDropdownLink =
    "flex px-6 py-6 text-sm font-medium items-center text-rhoBlueDark-400 bg-rhoOffWhite-100 hover:bg-gradient-to-r hover:from-rhoTan-400 hover:to-rhoTan-200 hover:text-rhoBlueDark-700 transition-all duration-300";
  let navMobileDropdownLink =
    "flex items-center py-4 text-sm font-medium text-gray-600 hover:text-gray-900";
  let columnLinksClassName =
    "flex gap-x-4 py-2 text-sm text-rhoBlueDark-700 hover:text-rhoBlueLight-700 items-center text-align-left";
  let liMobileClassName = "";

  const innovators = [
    {
      name: "Innovator Case Study",
      href: null,
      link: "/case-studies/robotic-inspections-in-advancing-sustainability-performance/",
      icon: "fa-regular fa-book",
    },
    {
      name: "Customer Stories",
      href: null,
      link: "/customers",
      icon: "fa-regular fa-users",
    },
  ];
  const investors = [
    {
      name: "ECO Framework Case Study",
      href: null,
      link: "/case-studies/2023-eco-report/",
      icon: "fa-regular fa-book",
    },
    {
      name: "Pre-investment Considerations",
      href: "https://projectframe.how/preinvestment-ghg-assessment",
      link: null,
      icon: "fa-regular fa-list-check",
    },
  ];
  const integrators = [
    {
      name: "Insights",
      href: null,
      link: "/insights",
      icon: "fa-regular fa-lightbulb",
    },
    {
      name: "Koi Docs",
      href: "https://docs.koi.eco",
      link: null,
      icon: "fa-regular fa-books",
    },
  ];
  const highlights = [
    {
      title: "Forecast Climate Impact",
      href: "https://koi.eco/",
      link: null,
      imageUrl: "../images/heros-and-graphics/koi-laptop1.png",
      description:
        "Sign up for free to search data available in Koi. Instant access to the world's most authoritative energy and environmental data.",
      containerClasses: "bg-rhoBlueDark-100 p-2 rounded-lg",
    },
  ];
  // create a function that accepts required properties
  // it returns a list item with the link or href
  function createListItem(linkClassName, link, href, name, icon) {
    return (
      <>
        {link ? (
          <Link to={link} className={linkClassName}>
            <i aria-hidden="true" className={`w-4 ${icon}`}></i>
            &nbsp;{name}
          </Link>
        ) : (
          <a
            href={href}
            className={linkClassName}
            target="_blank"
            rel="noreferrer"
          >
            <i aria-hidden="true" className={`w-4 ${icon}`}></i>
            &nbsp;{name}
          </a>
        )}
      </>
    );
  }

  if (mobile) {
    return (
      <ul>
        <li className={`${liMobileClassName}`}>
          <a
            href="https://koi.eco"
            className={`${navMobileDropdownLink} focus:outline-none`}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-kit fa-koi-icon-flat"></i>&nbsp;Koi
          </a>
        </li>
        <li className={`${liMobileClassName}`}>
          <a
            href="https://cranetool.org"
            className={`${navMobileDropdownLink} focus:outline-none`}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-kit fa-crane-icon-flat"></i>&nbsp;CRANE
          </a>
        </li>
      </ul>
    );
  } else {
    return (
      <ul className="max-w-6xl px-5 mx-auto sm:px-6 align-middle">
        <li className="p-2">
          <a
            href="https://koi.eco"
            className={`${navDropdownLink} focus:outline-none`}
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <h4 className="h4">
                <i className="fa-kit fa-koi-icon-flat"></i>&nbsp;Koi
              </h4>
              Rapidly assess climate impact across tens of thousands of
              technologies using the world's most authoritative energy and
              environmental data.
            </span>
          </a>
        </li>
        <li className="p-2">
          <a
            href="https://cranetool.org"
            className={`${navDropdownLink} focus:outline-none`}
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <h4 className="h4">
                <i className="fa-kit fa-crane-icon-flat"></i>&nbsp;CRANE
              </h4>
              The world's only comprehensive, free, and open-access resource to
              implement climate impact assessments based on consensus-based
              methodologies.
            </span>
          </a>
        </li>
        <li className="mx-auto grid grid-cols-4 gap-x-8 px-6 py-4 lg:px-8">
          <div className="grid col-span-3 grid-cols-3 gap-x-6 sm:gap-x-8">
            <div>
              <h3 className="text-md font-medium leading-6 text-rhoGray-500">
                for Innovators
              </h3>
              <p>
                From early ideation through global deployment, confidently
                communicate your solution's ability to make a positive impact.
              </p>
              <div className="mt-6 flow-root">
                <div className="-my-2">
                  {innovators.map((item, index) => (
                    <div
                      key={"innovators-" + index}
                      className={liMobileClassName}
                    >
                      {createListItem(
                        columnLinksClassName,
                        item.link,
                        item.href,
                        item.name,
                        item.icon
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-md font-medium leading-6 text-rhoGray-500">
                for Investors
              </h3>
              <p>
                Leverage data &amp; tools to capture investment opportunities as
                we transition to a low-carbon economy.
              </p>
              <div className="mt-6 flow-root">
                <div className="-my-2">
                  {investors.map((item, index) => (
                    <div
                      key={"investors-" + index}
                      className={liMobileClassName}
                    >
                      {createListItem(
                        columnLinksClassName,
                        item.link,
                        item.href,
                        item.name,
                        item.icon
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-md font-medium leading-6 text-rhoGray-500">
                for Integrators
              </h3>
              <p>
                Calling all academic institutions, data providers, consultants,
                policy makers, and others with a stake in the climate
                transition.
              </p>
              <div className="mt-6 flow-root">
                <div className="-my-2">
                  {integrators.map((item, index) => (
                    <div
                      key={"integrators-" + index}
                      className={liMobileClassName}
                    >
                      {createListItem(
                        columnLinksClassName,
                        item.link,
                        item.href,
                        item.name,
                        item.icon
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-10 sm:gap-8">
            <h3 className="sr-only">Recent posts</h3>
            {highlights.map((highlight, index) => (
              <article
                key={index}
                className={`relative isolate flex max-w-2xl flex-col gap-x-8 gap-y-6 sm:flex-row sm:items-start lg:flex-col lg:items-stretch ${highlight.containerClasses}`}
              >
                <div className="relative flex-none">
                  <div
                    className="w-full min-h-32 lg:h-auto bg-cover bg-center rounded-lg"
                    style={{
                      backgroundImage: `url(${
                        require("../images/heros-and-graphics/koi-laptop1.png")
                          .default
                      })`,
                    }}
                  ></div>
                </div>
                <div>
                  <h4 className="text-sm font-semibold">
                    {highlight.link ? (
                      <Link to={highlight.link}>
                        <span className="absolute inset-0" />
                        {highlight.title}
                      </Link>
                    ) : (
                      <a href={highlight.href} target="_blank" rel="noreferrer">
                        <span className="absolute inset-0" />
                        {highlight.title}
                      </a>
                    )}
                  </h4>
                  <p className="mt-2 text-sm leading-6">
                    {highlight.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </li>
      </ul>
    );
  }
}

export default NavBarProducts;
